import { render, staticRenderFns } from "./ProjectWork.vue?vue&type=template&id=0d7a547c&scoped=true&"
import script from "./ProjectWork.vue?vue&type=script&lang=js&"
export * from "./ProjectWork.vue?vue&type=script&lang=js&"
import style0 from "./ProjectWork.vue?vue&type=style&index=0&id=0d7a547c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7a547c",
  null
  
)

export default component.exports